import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputTextarea } from 'primereact/inputtextarea';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { TENDER_STATUS, TENDER_COMMENT_REQUIRED_STATUSES } from '../utils/tenderRequestStatus';

// bkz. docs/LMS-IHALE--FE-Dokumani.txt §4 — Red (40) ve İade (15) için yorum zorunlu.
const TITLE_I18N_KEY = {
    [TENDER_STATUS.PENDING_APPROVAL]: 'sendForApprovalTitle',
    [TENDER_STATUS.ACCEPTED]: 'acceptTitle',
    [TENDER_STATUS.REJECTED]: 'rejectTitle',
    [TENDER_STATUS.RETURNED]: 'returnTitle'
};

const TenderStatusChangeDialog = ({ visible, targetStatus, onHide, onConfirm, loading }) => {
    const { th } = useLanguage();
    const [comment, setComment] = useState('');
    const [submitted, setSubmitted] = useState(false);
    const commentRequired = TENDER_COMMENT_REQUIRED_STATUSES.includes(targetStatus);

    useEffect(() => {
        if (visible) {
            setComment('');
            setSubmitted(false);
        }
    }, [visible, targetStatus]);

    const isInvalid = submitted && commentRequired && !comment.trim();
    const titleKey = TITLE_I18N_KEY[targetStatus];

    const handleConfirm = () => {
        setSubmitted(true);
        if (commentRequired && !comment.trim()) return;
        onConfirm?.(comment.trim());
    };

    return (
        <Dialog visible={visible} onHide={onHide} header={titleKey ? th(`tenderRequest.statusChange.${titleKey}`) : ''} modal className="p-fluid" style={{ width: '30vw', minWidth: '360px' }}>
            <div className="field">
                <label htmlFor="tenderStatusChangeComment">
                    {th('tenderRequest.statusChange.commentLabel')} {commentRequired && <span className="text-red-500">*</span>}
                </label>
                <InputTextarea
                    id="tenderStatusChangeComment"
                    value={comment}
                    onChange={(e) => setComment(e.target.value)}
                    rows={4}
                    autoResize
                    maxLength={1000}
                    placeholder={th('tenderRequest.statusChange.commentPlaceholder')}
                    className={isInvalid ? 'p-invalid' : ''}
                />
                {isInvalid && <small className="text-red-500">{th('tenderRequest.statusChange.commentRequiredError')}</small>}
            </div>
            <div className="flex justify-content-end gap-2 mt-3">
                <Button label={th('common.cancel')} icon="pi pi-times" outlined onClick={onHide} type="button" />
                <Button label={th('tenderRequest.statusChange.confirm')} icon="pi pi-check" onClick={handleConfirm} loading={!!loading} type="button" />
            </div>
        </Dialog>
    );
};

export default TenderStatusChangeDialog;
